import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {POLL_RESPONSE,POLL_RESPONSE_WEB} from "../../../Config/ApiUrl";
import {formatDateTimeToLocalDate} from "../../../../common/Helper/Support/DateTimeHelper";
import {pollOptionFilterMixin, pollQuestionFilterMixin, UserFilterMixin} from "../FilterMixin";

export default {
    mixins: [DatatableHelperMixin,pollQuestionFilterMixin,UserFilterMixin,pollOptionFilterMixin],
    data() {
        return {
            options: {
                name: this.$t('pollResponses.title'),
                url: POLL_RESPONSE,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('pollResponses.answer_text'),
                        type: 'text',
                        key: 'answer_text',
                        isVisible: true,
                    },
                    {
                        title: this.$t('pollQuestion'),
                        type: 'custom-html',
                        key: 'poll_question',
                        isVisible: true,
                        modifier: poll_question => {
                            return poll_question.question_text
                        }
                    },
                    {
                        title: this.$t('user'),
                        type: 'custom-html',
                        key: 'user',
                        isVisible: true,
                        modifier: user => {
                            return user.full_name
                        }
                    },
                    {
                        title: this.$t('pollOption'),
                        type: 'custom-html',
                        key: 'poll_option',
                        isVisible: true,
                        modifier: poll_option => {
                            // Check if poll_option is not null and has option_text
                            return poll_option && poll_option.option_text ? poll_option.option_text : null;
                        }
                    },
                    {
                        title: this.$t('pollResponses.submitted'),
                        type: 'custom-html',
                        key: 'submitted_at',
                        isVisible: true,
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value);
                        }
                    },
                    {
                        title: this.$t('created'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value);
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('pollQuestion'),
                        type: "multi-select-filter",
                        key: "pollQuestions",
                        option: [],
                        listValueField: 'question_text',
                        permission: !!this.$can('view_poll_questions')
                    },
                    {
                        title: this.$t('pollOption'),
                        type: "multi-select-filter",
                        key: "pollOptions",
                        option: [],
                        listValueField: 'option_text',
                        permission: !!this.$can('view_poll_options')
                    },
                    {
                        title: this.$t('user'),
                        type: "multi-select-filter",
                        key: "users",
                        option: [],
                        listValueField: 'full_name',
                        permission: !!this.$can('view_users')
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('view_details'),
                        key: "view_details",
                        name: 'view_details',
                        url: POLL_RESPONSE_WEB,
                    },
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-poll-response-modal',
                        modalId: 'poll-response-modal',
                        url: POLL_RESPONSE,
                        name: 'edit',
                        modifier: row => this.$can('update_poll_response')
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'poll-response-modal',
                        url: POLL_RESPONSE,
                        name: 'delete',
                        modifier: row => this.$can('delete_poll_response')
                    },
                ],
            }
        }
    }
}
